<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.section--login
      +b.VALIDATION-OBSERVER(
        ref="observer"
        tag="form"
        class="form"
      )
        +b.withdraw--initial
          +b.ma--b_1md.TEXT-BEMTO(
            :fw="'bold'"
            :lh="'initial'"
            :fs="'4xl'"
            :color="'black'"
            :tag="'p'"
          ) Withdraw
          +b.ug-row--apearance_spaced.--space_md.--align_end
            +b.ug-cell.g-cols--narrow
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'initial'"
                :fs="'xl'"
                :color="'black'"
                :tag="'p'"
              ) BALANCE
            +b.ug-cell.g-cols--narrow
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'initial'"
                :fs="'6xl'"
                :color="'black'"
                :tag="'p'"
              ) {{ formData.amount }} &#163
          validation-provider(
            v-slot="{ errors }"
            name="amount"
          )
            +b.mb-15.ma--b_md.--t_md.TEXT-BEMTO(
              v-if="errors"
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'red'"
              :tag="'p'"
            ) {{ errors[0] }}
          +b.ma--t_1md
            +b.ug-row--apearance_spaced.--space_md
              +b.ug-cell.ug-cols--12
                +b.input--modal.D-CONTROL-INPUT(
                  v-model="formData.comment"
                  :placeholder="'Comment'"
                  :name="'comment'"
                  :type="'text'"
                  id="comment"
                )
              +b.ug-cell.ug-cols--12
                validation-provider(
                  :rules="'required'"
                  v-slot="{errors}"
                  name="attachmentFile"
                )
                  +b.upload-list--initial
                    +e.file-wrapper.INPUT(
                      ref='fileLoader'
                      type="file"
                      id="attachmentFile"
                      @change="setFileHandler"
                    )
                    +e.file-wrapper.INPUT(
                      v-model="fileName"
                      type="text"
                      name="attachmentFile"
                    )
                    +b.button--height_xl.LABEL(
                      v-show="!isActive"
                      for="attachmentFile"
                    ) ADD INVOICE
                    +e.item--initial.LABEL(
                      v-show="isActive"
                    )
                      text-bemto(
                        :fw="'medium'"
                        :lh="'small'"
                        :fs="'xs'"
                        :color="'black'"
                        :tag="'p'"
                      ) {{ fileName }}
                      +e.remove--initial.TEXT-BEMTO(
                        :fw="'medium'"
                        :lh="'small'"
                        :fs="'xs'"
                        :color="'black'"
                        :tag="'p'"
                        @event="delFileHandler"
                      ) x
                    +e.error.c--red {{ errors[0] }}
              +b.ug-cell.ug-cols--12
                +b.button--height_xl.--save.BUTTON-BEMTO(
                  :disabled="isRequest"
                  @event="validateBeforeSubmit(formData)"
                )
                  +e.load.IMG(
                    src="/static/load.gif"
                    v-if="isRequest"
                  )
                  +e.text(
                    v-if="!isRequest"
                  ) SEND
</template>

<script>
import FormMixin, {defaultValidatorErrorsParser} from '@/js/mixins/FormMixin'
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'
import {getDrawBalanceAPI, postDrawOutputAPI} from '@/js/services/cabinet'

export default {
  name: 'WithdrawCabinet',
  mixins: [
    FormMixin,
    ToggleModalMixin,
  ],
  created() {
    this.getDrawBalanceAPI()
  },
  data() {
    return {
      /**
       * Components state.
       */
      formData: {
        amount: null,
        comment: null,
        attachmentFile: null,
      },
      isRequest: false,
      fileName: null,
      isActive: false
    }
  },
  methods: {
    getDrawBalanceAPI() {
      return getDrawBalanceAPI.execute({})
        .then(response => {
          const BALANCE = response.data.item.balance
          this.formData.amount = Number(BALANCE)
        })
    },
    /**
     * Submission handler, if validated.
     * @param { Object } data - Send data.
     */
    async send(data) {
      await postDrawOutputAPI.execute(
        {}, data
      )
        .then(response => {
          const OPTIONS = {
            title: response.data.item.message,
          }
          /**
           * Clear component state.
           */
          this.$refs.observer.reset()
          this.formData.amount = '0.00'
          this.formData.comment = null
          this.formData.attachmentFile = null
          this.fileName = null
          this.isActive = false
          /**
           * Show success message.
           */
          this.toggleModalMixin(
            'SuccessCommon', OPTIONS
          )
        })
    },
    /**
     * Set file on components state handler.
     */
    async setFileHandler(event) {
      const file = event.target.files[0]
      const FR = new FileReader()

      this.fileName = file.name
      this.isActive = true

      FR.onload = e => {
        this.formData.attachmentFile = `${file.name};${e.target.result}`
      }
      FR.readAsDataURL(file)
    },
    /**
     * Delete file on components state handler.
     */
    delFileHandler() {
      this.formData.attachmentFile = null
      this.$refs.fileLoader.value = null
      this.$refs.observer.reset()
      this.fileName = null
      this.isActive = false
    },
    /**
     * After > error display normalization >
     * Set Observer errors.
     *
     * @param { Object } errors - Formatted errors
     */
    setErrors(errors) {
      const error = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(error)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/WithdrawCabinet.vue